export const services = [
  {
    id: 0,
    name: "Benne 3m³",
    delay: "24h",
    description: "Petits travaux : terre et gravats uniquement",
    priceGravats: "Dès 245€ HT",
    priceMelange: null,
    dimensions: "Dimensions à confirmer selon la benne",
    capacity: "3m³"
  },
  {
    id: 1,
    name: "Benne 8m³",
    delay: "24h",
    description: "Pour travaux moyens et rénovations complètes",
    priceGravats: "Dès 300€ HT",
    priceMelange: "Dès 400€ HT",
    dimensions: "L: 3.5m x l: 1.8m x h: 1.5m",
    capacity: "8m³"
  },
  {
    id: 2,
    name: "Benne 10m³",
    delay: "24h",
    description: "Pour grands chantiers de démolition",
    priceGravats: "Dès 350€ HT",
    priceMelange: "Dès 480€ HT",
    dimensions: "L: 4m x l: 2m x h: 1.6m",
    capacity: "10m³"
  },
  {
    id: 3,
    name: "Benne 15m³",
    delay: "24h",
    description: "Pour chantiers de grande envergure",
    priceGravats: null,
    priceMelange: "Dès 675€ HT",
    dimensions: "L: 4.5m x l: 2.2m x h: 1.8m",
    capacity: "15m³"
  },
  {
    id: 4,
    name: "Benne 20m³",
    delay: "24h",
    description: "Pour projets de rénovation d'envergure",
    priceGravats: null,
    priceMelange: "Dès 860€ HT",
    dimensions: "L: 5m x l: 2.3m x h: 2m",
    capacity: "20m³"
  },
  {
    id: 5,
    name: "Benne 30m³",
    delay: "24h",
    description: "Pour projets industriels et grands travaux",
    priceGravats: null,
    priceMelange: "Dès 1185€ HT",
    dimensions: "L: 6m x l: 2.4m x h: 2.2m",
    capacity: "30m³"
  }
];

export const additionalServices = [
  {
    id: 1,
    icon: "Truck",
    name: "Collecte en camionnette",
    description: "Camions de 6m³, 12m³ ou 20m³",
    details: "Forfaits Chargement, Transport et Traitement déchets"
  },
  {
    id: 2,
    icon: "Recycle",
    name: "Sacs et vrac",
    description: "Intervention rapide en 3h",
    details: "Solution flexible pour petits volumes"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Thierry C.",
    company: "Particulier",
    rating: 5,
    text: "Cordial et réactif au téléphone, nous avions besoin d'une benne pour évacuer 8m³ de gravats. La benne est arrivée à l'heure et la manœuvre délicate pour déposer la benne dans le jardin s'est effectuée avec délicatesse et précision."
  },
  {
    id: 2,
    name: "Benoît O.",
    company: "Entrepreneur",
    rating: 5,
    text: "Suite à une succession, nous avons dû louer une benne pour débarrasser une maison. Très réactif, très bonne estimation de la quantité à enlever. Et très bon suivi commercial, je recommande vraiment."
  },
  {
    id: 3,
    name: "Guillaume D.",
    company: "Artisan BTP",
    rating: 5,
    text: "Très satisfait de l'ensemble de la prestation. Ils ont très bien pris en compte toutes mes contraintes et ont été super réactifs contrairement à d'autres prestataires par qui je suis aussi passé."
  },
  {
    id: 4,
    name: "Marie L.",
    company: "Architecte",
    rating: 5,
    text: "Service impeccable pour notre chantier de rénovation. Livraison dans les délais, équipe professionnelle et prix compétitifs. Je recommande vivement pour tous vos projets."
  }
];

export const faqItems = [
  {
    id: 1,
    question: "Comment fonctionne la location de benne ?",
    answer: "Les locations de benne incluent la livraison, la location pendant 15 jours calendaires, le transport et le traitement des déchets. Le chargement est à faire par vos soins. Nous pouvons vous livrer une benne sur chantier 24 heures après commande."
  },
  {
    id: 2,
    question: "Quelles sont les dimensions requises pour accéder à mon terrain ?",
    answer: "Pour que le camion puisse déposer et reprendre la benne, un espace dégagé d'au moins 3,5 mètres de largeur, 4 mètres de hauteur et 10 mètres de longueur est nécessaire (conditions rappelées à la commande)."
  },
  {
    id: 3,
    question: "Quel est le délai d'intervention ?",
    answer: "Après validation ou paiement du devis, nous pourrons intervenir 24 heures après. Les créneaux de livraison proposés sont 8h–12h, 12h–16h ou 8h–16h."
  },
  {
    id: 4,
    question: "Quels déchets sont acceptés ?",
    answer: "Il y a deux types de bennes : DIB (mélange) acceptant déchets non dangereux, bois, plâtres, plastiques, cartons, métaux ; et Terres/Gravats acceptant gravats, béton, parpaings, tuiles, terre, pierres. Les déchets alimentaires et dangereux sont refusés."
  },
  {
    id: 5,
    question: "Comment obtenir une autorisation pour voie publique ?",
    answer: "C'est à votre charge de faire une demande d'autorisation de voirie auprès de la Mairie (voie communale), du département (route départementale) ou de la DIR (autoroute/route nationale). Le CERFA n° 14023*01 est généralement requis."
  },
  {
    id: 6,
    question: "Qu'est-ce que le chargement express ?",
    answer: "Le chargement Express (45 minutes) vous permet d'éviter les demandes d'autorisation et libère rapidement l'accès sur chantier. Vous disposez de 45 minutes maximum pour charger la benne."
  },
  {
    id: 7,
    question: "Sur quelles zones êtes-vous disponibles ?",
    answer: "Nous réalisons de la location de benne dans toute l'Ile-de-France. N'hésitez pas à nous solliciter pour tous vos projets en région parisienne."
  },
  {
    id: 8,
    question: "Quel est le prix d'un passage à vide ?",
    answer: "Un Passage à vide (PAV), si le chauffeur ne peut pas déposer ou récupérer la benne sur place, est facturé 180 € HT, conformément aux conditions acceptées à la commande. Assurez-vous d'être bien présent pendant la livraison et le retrait."
  }
];

export const blogArticles = [
  {
    id: 1,
    title: "Location benne de chantier : guide complet sur les tailles et prix",
    excerpt: "Choisir la bonne benne de chantier : taille, type et coût. Guide essentiel pour professionnels et particuliers en rénovation.",
    date: "15 janvier 2025",
    category: "Guide",
    image: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=800&q=80"
  },
  {
    id: 2,
    title: "Le Guide Ultime de la Benne 30m³ : Tout ce que Vous Devez Savoir !",
    excerpt: "Découvrez la benne 30m³ : solution optimale pour la gestion des déchets sur vos grands chantiers. Efficacité et adaptation garanties.",
    date: "10 janvier 2025",
    category: "Guide",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80"
  },
  {
    id: 3,
    title: "Recyclage et valorisation de vos déchets de chantier",
    excerpt: "Comprendre l'importance du recyclage dans le secteur du BTP. Comment nous revalorisons les déchets collectés en centre agréé.",
    date: "5 janvier 2025",
    category: "Écologie",
    image: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=800&q=80"
  },
  {
    id: 4,
    title: "Amiante : Risques et innovations pour protéger votre santé",
    excerpt: "Découvrez l'histoire et les risques de l'amiante. L'importance de la sensibilisation et de la prévention dans la construction.",
    date: "28 décembre 2024",
    category: "Sécurité",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80"
  }
];

export const partners = [
  { id: 1, name: "Saint-Gobain", logo: "SG" },
  { id: 2, name: "Cedeo", logo: "CD" },
  { id: 3, name: "La Plateforme du Bâtiment", logo: "PB" },
  { id: 4, name: "Kiloutou", logo: "KL" },
  { id: 5, name: "Asturienne", logo: "AS" },
  { id: 6, name: "Derichebourg", logo: "DB" }
];

export const stats = [
  { id: 1, value: "105 000", label: "Tonnes de déchets collectées", suffix: "T" },
  { id: 3, value: "24", label: "Délai de livraison", suffix: "h" },
  { id: 4, value: "15 000", label: "Clients satisfaits", suffix: "+" }
];